import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createTextVNode as p, Fragment as u, Comment as y } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function i(f, t = !0, n = []) {
  return f.forEach((r) => {
    if (r !== null) {
      if (typeof r != "object") {
        (typeof r == "string" || typeof r == "number") && n.push(p(String(r)));
        return;
      }
      if (Array.isArray(r)) {
        i(r, t, n);
        return;
      }
      if (r.type === u) {
        if (r.children === null)
          return;
        Array.isArray(r.children) && i(r.children, t, n);
      } else {
        if (r.type === y && t)
          return;
        n.push(r);
      }
    }
  }), n;
}
export {
  i as flatten
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/flatten.js
// module id = 310
// module chunks = 41